import React, { memo, useEffect } from 'react';
import ReactGA from 'react-ga';
import { useTranslation } from 'react-i18next';
import TwoFAManager from '../../containers/TwoFAManager';
import TwoFAOldWallet from '../../containers/TwoFAOldWallet';
import TwoFARow from '../../containers/TwoFARow';
import shieldIcon from '../../img/icons/shield.svg';
import style from '../../style/components/signin/TwoFA.module.scss';
import {
  BACKUPCODES,
  DEVICEKEY,
  FIDOKEY,
  GENERATOR,
  PHONE,
  PUSH,
  YUBIKEY,
} from '../../constants/mfa';
import Card from '../Card';
import { getReactEnv } from '../../constants';

const TwoFA = () => {
  const { t } = useTranslation();

  useEffect(() => {
    if (getReactEnv() === 'production') {
      ReactGA.pageview(window.location.pathname);
    }
  }, []);

  return (
    <Card
      title={t('multiFactor.title')}
      icon={<img alt="shield" src={shieldIcon} />}
      className={style.wrapper}
    >
      <p>
        {t('multiFactor.description_intro')}
        <br />
        {t('multiFactor.description_benefit')}
      </p>

      <TwoFAManager />
      <TwoFAOldWallet />
      <TwoFARow mfaHandle={DEVICEKEY} />
      <TwoFARow mfaHandle={PHONE} />
      <TwoFARow mfaHandle={PUSH} />
      <TwoFARow mfaHandle={GENERATOR} />
      <TwoFARow mfaHandle={FIDOKEY} />
      <TwoFARow mfaHandle={YUBIKEY} />
      <TwoFARow mfaHandle={BACKUPCODES} />
    </Card>
  );
};

export default memo(TwoFA);
